import { getAuth } from '@/lib/login/auth';
import { loadCreatorDetails } from '../onboarding/services/load-creator-details';
import { SIGNED_OUT_VIEWER, type Viewer } from '../shared/viewer';

/**
 * The landing route's loader: who's visiting, so the page renders the right
 * buttons on the server (no swap after it loads). Server auth on SSR, the
 * browser's on client navigation; the root route re-runs it when sign-in
 * changes. Never throws: if the creator details can't be loaded, the visitor
 * isn't treated as a creator.
 */
export async function loadViewer(): Promise<Viewer> {
	const auth = await getAuth();
	if (!auth.isLoggedIn()) return SIGNED_OUT_VIEWER;
	try {
		const details = await loadCreatorDetails();
		return { isLoggedIn: true, isCreator: details.status === 'APPROVED' };
	} catch {
		return { isLoggedIn: true, isCreator: false };
	}
}
